import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";

import { IntlProvider, addLocaleData } from "react-intl";
import localeDE from "react-intl/locale-data/de";

import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

import ReactDOM from "react-dom";
import { composeWithDevTools } from "redux-devtools-extension";
import App from "./App";
import registerServiceWorker from "./util/registerServiceWorker";
import rootReducer from "./reducers/rootReducer";

/**
 * Add locales and install localizations
 */
import translationsDE from "./translations/de.json";

addLocaleData([...localeDE]);

const translations = {
  de: translationsDE
};
const language = "de";

/**
 * Create a Redux store or load from local storage
 */
const persistedState = localStorage.getItem("reduxState")
  ? JSON.parse(localStorage.getItem("reduxState"))
  : {};
const store = createStore(
  rootReducer,
  persistedState,
  composeWithDevTools(applyMiddleware(thunk))
);

/**
 * Update local storage based on redux state
 */
store.subscribe(() => {
  const { user, settings, tasklist } = store.getState();
  const persistedStore = {
    user,
    settings,
    tasklist
  };

  localStorage.setItem("reduxState", JSON.stringify(persistedStore));
});

/**
 * Render the application.
 */
ReactDOM.render(
  <IntlProvider locale={language} messages={translations[language]}>
    <BrowserRouter>
      <Provider store={store}>
        <Route component={App} />
      </Provider>
    </BrowserRouter>
  </IntlProvider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js